import _ from 'lodash'
import { AxiosRequestConfig } from 'axios'
import { authInterceptor } from '@/modules/auth'
import { notify, Colors } from '@/modules/core/notification';
import KeyValuePair from './modules/core/support/KeyValuePair';
import {getHost, axios as client } from '@/plugins/axios';

/**
 * Intercepta las respuesta rechazadas, aquellas cuyo código de estado esta fuera del
 * rango 100 a 299.
 *
 * Muestra al usuario una notificación con el error
 *
 * @param error
 */
const notifyErrorInterceptor = async (error: Error) => {
    notify(_.get(error, 'response.data.message', error.message), Colors.Error)

    throw error
}

client.interceptors.request.use(authInterceptor)
client.interceptors.response.use(undefined, notifyErrorInterceptor)

interface RequestConfig {
    url: string,
    method: string,
    params?: KeyValuePair<string | number>
    body?: KeyValuePair | FormData,
}

/**
 * Obtiene un recurso de la API
 *
 * @param resource
 * @param options
 */
export async function fetch (resource: string, options: AxiosRequestConfig = {}) {
    return (await client.get(resource, options)).data
}

/**
 * Registra un recurso en la API
 * @param resource
 * @param data
 * @param options
 */
export async function post (resource: string, data: KeyValuePair | FormData, options: AxiosRequestConfig = {}) {
    return (await client.post(resource, data, options)).data
}

/**
 * Actualiza un recurso de la API
 * @param resource
 * @param data
 * @param options
 */
export async function put (resource: string, data: KeyValuePair, options: AxiosRequestConfig = {}) {
    return (await client.put(resource, data, options)).data
}

/**
 * Elimina un recurso de la API
 *
 * @param resource
 * @param data
 * @param options
 */
export async function remove (resource: string, options: AxiosRequestConfig = {}) {
    return (await client.delete(resource, options)).data
}



export { getHost }
export default client
